<template>
  <div class="go-study-popup" v-if="isShowPopup">
    <div class="mask">
      <div class="popup">
        <div class="popup-container">
          <div class="popup-title-wrapper">
            <div class="title-text">去学习</div>
          </div>
          <div class="popup-content-wrapper">
            <div class="popup-content-container">
              <learn-lite v-if="learnData" :init-data="learnData" />
            </div>
          </div>
          <div class="popup-btn-wrapper" @click="closePopup">
            <div class="popup-btn-container">
              <div class="btn-text">关&nbsp;&nbsp;闭</div>
            </div>
          </div>
        </div>
        <div class="close-btn" @click="closePopup">
          <img
            class="close-btn-img"
            src="../../../assets/images/home/ic_fork@2x.png"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LearnLite from './LearnComponentLite.vue'
export default {
  name: 'goStudyPopup',
  components: {
    LearnLite
  },
  props: {
    isShowPopup: {
      type: Boolean,
      default: false
    },
    initData: {
      type: Object
    }
  },
  data() {
    return {
      learnData: []
    }
  },
  watch: {
    isShowPopup: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.getInfo()
        }
      },
      deep: true // 深度监听
      //   immediate: true
    }
  },
  methods: {
    getInfo() {
      this.learnData = this.initData.stages
      console.log(
        '🚀 ~ file: goStudyPopup.vue:65 ~ getInfo ~ learnData:',
        this.learnData
      )
    },
    closePopup() {
      this.$emit('closePopup')
    }
  }
}
</script>

<style lang="less" scoped>
.go-study-popup {
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  max-width: 100vw;
  max-height: 100vh;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  position: fixed;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.6);
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    min-height: 100vh;
    padding-bottom: 40px;
    box-sizing: border-box;
    .popup {
      width: 300px;
      height: 491px;
      position: relative;
      margin: 0 auto;
      margin-top: 20%;
      // transform: translate(-50%, -50%);
      background-image: url("../../../assets/images/home/bg_low2@2x.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      .popup-container {
        width: 300px;
        height: 491px;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        // background-image: url('../../../assets/images/home/bg_low2@2x.png');
        // background-size: 100% 100%;
        // background-repeat: no-repeat;
        z-index: 10;
        .popup-title-wrapper {
          width: 272px;
          margin-top: 22px;
          .title-text {
            height: 22px;
            font-size: 16px;
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 500;
            color: #000000;
            line-height: 22px;
          }
        }
        .popup-content-wrapper {
          width: 270px;
          height: 315px;
          margin-top: 24px;
          position: relative;
          overflow-x: hidden;
          overflow-y: scroll;
          .popup-content-container {
            top: 0;
            left: 0;
            overflow-x: hidden;
            overflow-y: scroll;
            width: 100%;
            min-height: 315px;
            position: absolute;
            overscroll-behavior-x: contain;
          }
        }
        .popup-btn-wrapper {
          position: absolute;
          left: 50%;
          bottom: 21px;
          transform: translateX(-50%);
          width: 272px;
          height: 40px;
          background-color: #EB1700;
          border-radius: 4px;
          display: flex;
          justify-content: center;
          align-items: center;
          .popup-btn-container {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            .btn-text {
              height: 20px;
              font-size: 14px;
              font-family: Source Han Sans CN, Source Han Sans CN;
              font-weight: 400;
              color: #ffffff;
              line-height: 20px;
            }
          }
        }
      }
      .close-btn {
        position: absolute;
        top: -45px;
        right: 0px;
        width: 28px;
        height: 28px;
        .close-btn-img {
          width: 28px;
          height: 28px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/components/goStudyPopup.vue